import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type DragMatchingTextStylesType = {
  outerDiv: CSSProperties;
  textChoicesContainer: CSSProperties;
  textChoice: CSSProperties;
  textContainer: CSSProperties;
  imageContainer: CSSProperties;
  image: CSSProperties;
};

export const DragMatchingTextStyles: DragMatchingTextStylesType = {
  outerDiv: {
    ...cssClass.outerDiv,
    gap: "5%",
  },

  textChoicesContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    gap: "10px",
    ...cssClass.fontFamily,
  },

  textChoice: {
    position: "relative",
    textAlign: "center",
    fontSize: "1.5rem",
    wordBreak: "break-word",
    height: "40px",
    ...cssClass.centerFlex,
    ...cssClass.fontFamily,
    ...cssClass.button,
  },

  textContainer: {
    ...cssClass.textContainerBase,
    padding: "10px",
  },

  imageContainer: {
    overflow: "hidden",
    ...cssClass.centerFlex,
    borderRadius: "15px",
    backgroundColor: backgroundColors.white,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    // aspectRatio: "4/3",
  },

  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};
